// @flow
import { Map } from "immutable";

export const selectedLocationIdSelector = (state: Map<string, any>) =>
  state.getIn(["location", "selectedLocationId"]);

export const locationsSelector = (state: Map<string, any>) =>
  state.getIn(["location", "locations"]);

export const selectedLocationSelector = (state: Map<string, any>) =>
  state.getIn(["location", "selectedLocation"]);
  
export const locationIdsSelector = (state: Map<string, any>) =>
  state.getIn(["location", "locations"]).map(l => l.get('locationId'));


// WEBPACK FOOTER //
// ./src/features/location/store/locationSelectors.js